import { render, staticRenderFns } from "./showItemgroups.vue?vue&type=template&id=15b25053&scoped=true&"
import script from "./showItemgroups.vue?vue&type=script&lang=js&"
export * from "./showItemgroups.vue?vue&type=script&lang=js&"
import style0 from "./showItemgroups.vue?vue&type=style&index=0&id=15b25053&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b25053",
  null
  
)

export default component.exports